function t(t){return null!==t&&"object"==typeof t&&"function"==typeof t.start}export{t as isAnimationControls};
